<template>

  <div style=" display: flex;
    flex-direction: column; justify-content: center;">

    <div class="title" style="height: 150px; display: flex;
    justify-content: center;">
      <H2>最近挂号日志</H2>
    </div>

    <div style=" display: flex;
    justify-content: center;     height: 100px;     ">
      <div style="white-space: pre-wrap; "> 
        {{ rzjl }}
          <div slot="footer" style="display: flex;">
            <el-button @click="quit">返 回</el-button>
          </div>
      </div>
    </div>

  </div>

  

</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';

export default {
  name: "zh",
  data() {
    return {
      rzjl: '',
      loginId: this.$route.query.id,
      password: this.$route.query.password,
    }
  },
  
  // beforeCreate() {
  //   document.querySelector('body').classList.add("overall");
  // },
  // beforeDestroy() {
  //   document.querySelector('body').classList.remove("overall");
  // },

  mounted() {

    this.rzck();
  },

  methods: {
  


    quit() {
      this.$router.push({path: '/gj',
      query: { username: this.loginId , password: this.password}});
    },

    rzck() {
      this.getRequest("xundao/rzck?id=" + this.loginId).then(resp => {
        if (resp) {
          this.rzjl = resp.obj
        }
      });
    },
    
  }
}
</script>

<style>
/* 响应式样式 */
@media screen and (max-width: 768px) {
  .el-input, .el-button {
    width: 100%;
  }
}

.overall {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url("../assets/image.png");
  background-size: cover;
}

</style>